__turbopack_context__.v({
  "body": "TestResultModal-module__7sf7Eq__body",
  "failed": "TestResultModal-module__7sf7Eq__failed",
  "passed": "TestResultModal-module__7sf7Eq__passed",
  "status": "TestResultModal-module__7sf7Eq__status",
  "text": "TestResultModal-module__7sf7Eq__text",
});
